import { Box, IconButton, Stack, Typography, useTheme } from "@mui/material";
import { ReactComponent as AddIcon } from "Components/_Shared/Icons/Assets/add.svg";
import { ReactComponent as SubtractIcon } from "Components/_Shared/Icons/Assets/subtract.svg";
import { TextInput } from "Components/_Shared/Inputs/TextInput";
import { Spacing } from "Infrastructure/Themes/Themes";
import { Resources, useResource } from "Infrastructure/Translations/Resources";

type Props = {
  readonly value: number;
  readonly error?: boolean;
  readonly onBlur: React.FocusEventHandler<HTMLInputElement | HTMLTextAreaElement>;
  readonly onIncrement: () => void;
  readonly onDecrement: () => void;
  readonly isIncrementDisabled: boolean;
  readonly isDecrementDisabled: boolean;
  readonly readOnly: boolean;
};

export const RecurringAmountInput: React.FC<Props> = ({
  value,
  error,
  onBlur,
  onIncrement,
  onDecrement,
  isDecrementDisabled,
  isIncrementDisabled,
  readOnly,
}) => {
  const theme = useTheme();
  const { t } = useResource();

  return (
    <Stack spacing={Spacing.L}>
      <Typography variant="body2" fontWeight={600}>
        {t(Resources.AnalysisDetail.Modeling.ResourcesToInvest)}
      </Typography>
      <Box display="flex">
        <IconButton
          disabled={isDecrementDisabled}
          sx={{ width: theme.spacing(10), marginRight: theme.spacing(Spacing.M) }}
          onClick={onDecrement}
        >
          <SubtractIcon />
        </IconButton>
        <TextInput
          value={value}
          disabled={readOnly}
          name="allocatedAmount"
          unmask="typed"
          onBlur={onBlur}
          error={error}
          mask={[
            {
              mask: Number,
              thousandsSeparator: " ",
              min: 0,
              scale: 0,
            },
          ]}
          inputEndAdornment={
            <Typography variant="body2" color="secondary">
              {t(Resources.Common.CZKSuffix)}
            </Typography>
          }
        />
        <IconButton
          disabled={isIncrementDisabled}
          sx={{ width: theme.spacing(10), marginLeft: theme.spacing(Spacing.M) }}
          onClick={onIncrement}
        >
          <AddIcon />
        </IconButton>
      </Box>
    </Stack>
  );
};
